import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/permissions')({
  component: () => <Outlet />,
});
